import {
  createSIWEConfig,
  formatMessage,
  SIWECreateMessageArgs,
  SIWEVerifyMessageArgs,
} from "@reown/appkit-siwe";
import { bsc, mainnet, plasma, plumeMainnet } from "viem/chains";
import { generateSiweNonce } from "viem/siwe";

import { queryClient, referrerSessionKey } from "./constants";

import {
  getSessionStorageItem,
  removeSessionStorageItem,
} from "@/lib/session-storage";
import { makeRequest } from "@/network/api";
import { trackUserLogin } from "@/utils";

export const siweConfig = createSIWEConfig({
  signOutOnNetworkChange: false,
  getMessageParams: async () => ({
    domain: window.location.host,
    uri: window.location.origin,
    chains: [plumeMainnet.id, mainnet.id, bsc.id, plasma.id],
    statement: "Sign this message for auth.",
    expirationTime: new Date(Date.now() + 1000 * 60 * 60 * 24),
  }),
  createMessage: ({ address, ...args }: SIWECreateMessageArgs) =>
    formatMessage(args, address),
  getNonce: async () => generateSiweNonce(),
  getSession: async () =>
    makeRequest("/auth/checkSession").then((res) => res.json()),
  verifyMessage: async ({ message, signature }: SIWEVerifyMessageArgs) => {
    try {
      const referredByCode = getSessionStorageItem(referrerSessionKey);
      const res = await makeRequest("/auth/login", {
        method: "POST",
        body: JSON.stringify({ message, signature, referredByCode }),
      });
      if (res.ok) {
        return true;
      }
      console.error("Error verifying message", res.statusText);
      return false;
    } catch (error) {
      console.error("Error verifying message", error);
      return false;
    }
  },
  onSignIn: (session) => {
    queryClient.invalidateQueries();
    removeSessionStorageItem(referrerSessionKey);
    if (session?.address) {
      trackUserLogin(session.address);
    }
  },
  onSignOut: () => {
    queryClient.invalidateQueries();
    removeSessionStorageItem(referrerSessionKey);
  },
  signOut: async () => {
    try {
      const res = await makeRequest("/auth/logout", { method: "POST" });
      if (res.ok) {
        return true;
      }
      console.error("Error signing out", res.statusText);
      return false;
    } catch (error) {
      console.error("Error signing out", error);
      return false;
    }
  },
});
